export function makeShort() {
    $(this).find(".category_description_1").fadeOut(100);
    $(this).find(".category-icon").fadeOut(100);
    $(this).find("ul.dropdown-menu.level_2").fadeOut(150);

}